<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div>

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-0"
      >

        <div class="m-2">

          <!-- Table Top -->
          <b-row>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <span> تعداد کل : </span>
              <span class="mx-1">{{ totalCount }}</span>
            </b-col>

            <b-col
                cols="12"
                md="4"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="count"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector mx-50 w-50"
              />
              <label>تعداد</label>
            </b-col>

            <!-- Search -->
            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="debouncedSearch"
                    class="d-inline-block mr-1"
                    placeholder="جستجوی شماره موبایل، کد ملی، نام و نام خانوادگی ..."
                />
              </div>
            </b-col>
            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-md-0"
            >
              <b-button
                  variant="success"
                  class=""
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="downloadFile"
              >
                دانلود اکسل لیست
              </b-button>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="users"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <QueriedPagination v-if="totalCount" v-model="pageNumber" :total-counts="totalCount"
                                 :per-page="count"></QueriedPagination>


            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
    <!--    <b-modal-->
    <!--        id="modal-delete"-->
    <!--        centered-->
    <!--        ok-title="حذف"-->
    <!--        cancelTitle="انصراف"-->
    <!--        @ok="deleteCoupon(deleteItem)"-->
    <!--    >-->
    <!--      <span>حذف شود؟</span>-->
    <!--    </b-modal>-->
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormInput,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import {UsersGetTransgressiveUsersRequest} from "@/libs/Api/Users";
import QueriedPagination from "@/views/components/QueriedPagination.vue";
import {getUserData} from "@/auth/utils";
import axiosIns from "@/libs/axios";
import {saveAs} from 'file-saver';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  title: "لیست متخلفان - پنل ادمین لنزآوا ",
  data() {
    return {
      timeOut: null,
      coupons: null,
      users: [],
      showOverlay: false,
      totalCount: null,
      addNewCategory: false,
      currentPage: 1,
      deleteItem: null,
      perPage: 10,
      pageNumber: 1,
      count: 10,
      searchCommand: '',
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {key: 'fullName', label: 'اطلاعات کاربر'},
        {key: 'userName', label: 'نام کاربری'},
        {key: 'nationalId', label: 'کد ملی'},
        {key: 'mobile', label: 'موبایل'},
        // { key: 'reason',label:'تخلف'},
        {key: 'tryCopingVideoCount', label: 'تعداد دفعات تلاش برای کپی'},
        {key: 'useAppMoreThan2DeviceCount', label: 'تعداد دفعات ورود با بیش از یک دستگاه'},
      ],
      defaultCreateData: {
        isDeleted: false,
        productCategoryId: 0,
        parentId: 0,
        name: ''
      },
    }
  },
  async created() {
    if (this.$route.query.pageNumber) {
      this.pageNumber = +this.$route.query.pageNumber
      this.currentPage = +this.$route.query.pageNumber
    }
    await this.getTransgressiveUsers(this.pageNumber, this.count, this.searchCommand)
  },
  methods: {
    async getTransgressiveUsers(pageNumber, count, searchCommand) {
      let _this = this;

      _this.showOverlay = true;

      let data = {
        page: pageNumber,
        size: count,
        search: searchCommand
      }

      let usersGetTransgressiveUsersRequest = new UsersGetTransgressiveUsersRequest(_this);
      usersGetTransgressiveUsersRequest.setParams(data);
      await usersGetTransgressiveUsersRequest.fetch(function (content) {
        _this.users = content.data.data;
        _this.totalCount = content.data.totalCount;
        _this.showOverlay = false;
      }, function (error) {
        _this.showOverlay = false;
        console.log(error)
      })
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param
    },
    async downloadFile() {
      let _this = this;
      this.$store.commit('app/TOGGLE_DOWNLOAD')
      let userToken = getUserData().token;

      await axiosIns.post(`/Users/GetTransgressiveUsersExcel`, null, {
        responseType: 'blob',
      }).then(resp => {
        saveAs(resp.data, 'لیست متخلفان.xlsx');
      }).catch((error) => {
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: 'عملیات ناموق!',
            icon: 'CheckIcon',
            variant: 'danger',
            text: 'به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید',
          },
        })
      }).finally(() => {
        this.$store.commit('app/TOGGLE_DOWNLOAD')
      });
    },

  },
  watch: {
    getQuery: function (nv, ov) {
      this.getTransgressiveUsers(this.pageNumber, this.count, this.searchCommand);
    },

    count: function (nv, ov) {
      this.getTransgressiveUsers(this.currentPage, nv, this.searchCommand);
    },
  },
  computed: {
    getQuery() {
      return this.$route.query
    },
    debouncedSearch: {
      get() {
        return this.searchCommand
      },
      set(val) {
        if (this.timeOut) {
          clearTimeout(this.timeOut)
        }
        this.timeOut = setTimeout(async () => {
          this.searchCommand = val
          await this.getTransgressiveUsers(this.pageNumber, this.count, this.searchCommand)
        }, 600)
      }
    }
  },
  components: {
    QueriedPagination,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,

    vSelect,
  },
}
</script>

<style scoped>

</style>
